const user = {
  _id: '001',
  name: 'Daniel Adebonojo',
  email: 'adebonojod@gmail.com',
  avatar: 'https://avatars.githubusercontent.com/u/66811981?v=4',
  role: 'Admin',
};

export function getUser() {
  return user;
}
